import {Container, Singleton} from "typescript-ioc";
import {Tsl} from "@/model/ThingModel";
import StorageKey from "@/storage/StorageKey";
import BizStorage from './BizStorage';
import {LocalStorageWrapper} from "@/storage/StorageWrapper";

@Singleton
export default abstract class TslStorage extends BizStorage<Tsl> {
    protected key = StorageKey.TSL
}

class TslStorageImpl extends TslStorage {
    storage = Container.get(LocalStorageWrapper)
}

Container.bind(TslStorage).to(TslStorageImpl)
